"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logRocketTrack = logRocketTrack;

var _logrocket = _interopRequireDefault(require("logrocket"));

var _logRocketCookieUtils = require("./logRocketCookieUtils");

var _storage = require("../storage");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
function logRocketTrack(eventName) {
  var logRocketActive = (0, _storage.getCookie)(_logRocketCookieUtils.LOGROCKET_COOKIE);

  if (logRocketActive) {
    _logrocket.default.track(eventName);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola-helpers/client/dist/es/util/logrocket/logRocketTrack.js
// module id = 1135
// module chunks = 71